import { useState } from 'react';
import { trpc } from '../lib/trpc.js';
import { DiamondLogo } from '../components/ui/DiamondLogo.js';
import { useNavigate, useSearch } from '@tanstack/react-router';

export function LoginPage() {
  const navigate = useNavigate();
  const search = useSearch({ from: '/login' });
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const login = trpc.auth.login.useMutation({
    onSuccess: () => {
      const dest = (search as { redirect?: string }).redirect;
      if (dest && dest !== '/login') {
        window.location.href = dest;
      } else {
        navigate({ to: '/dashboard' });
      }
    },
    onError: (e) => setError(e.message),
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    login.mutate({ email, password });
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <DiamondLogo size={48} />
          </div>
          <h1 className="font-display text-3xl text-cream font-medium">LCC Cockpit</h1>
          <p className="text-cream/50 text-sm mt-1">Operational Intelligence Platform</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-xl p-6 shadow-2xl">
          {error && (
            <div className="mb-4 bg-red-50 border border-red-200 text-red-700 text-sm rounded-md px-3 py-2">
              {error}
            </div>
          )}

          <div className="mb-4">
            <label htmlFor="email" className="block text-xs font-medium text-gray-700 mb-1 uppercase tracking-wider">
              Email
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent"
            />
          </div>

          <div className="mb-6">
            <label htmlFor="password" className="block text-xs font-medium text-gray-700 mb-1 uppercase tracking-wider">
              Password
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent"
            />
          </div>

          <button
            type="submit"
            disabled={login.isPending}
            className="w-full bg-navy text-cream py-2.5 rounded-md text-sm font-medium hover:bg-navy-soft transition-colors disabled:opacity-50"
          >
            {login.isPending ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="text-center text-cream/30 text-xs mt-6">
          The London Carpet Clinic Ltd — Internal use only
        </p>
      </div>
    </div>
  );
}
